import { render, staticRenderFns } from "./LinkedUsersModal.vue?vue&type=template&id=48c3aa8a&scoped=true&"
import script from "./LinkedUsersModal.vue?vue&type=script&lang=ts&"
export * from "./LinkedUsersModal.vue?vue&type=script&lang=ts&"
import style0 from "./LinkedUsersModal.vue?vue&type=style&index=0&id=48c3aa8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c3aa8a",
  null
  
)

export default component.exports